import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import { Box, Grid, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useEffect } from "react";
import {
  FieldValues,
  FormContainer,
  TextFieldElement,
  useForm,
} from "react-hook-form-mui";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import useGetRegistrationFormInfo from "src/welcome/data-access/useGetRegistrationFormInfo";
import { registrationFormSchema } from "./validationSchema";
import useSubmitRegistration from "src/welcome/data-access/useSubmitRegistration";

function RegistrationForm() {
  const location = useLocation();

  const { t } = useTranslation();

  const { data, error } = useGetRegistrationFormInfo(location?.state?.bid);

  const { mutate, isLoading: isLoadingSubmit } = useSubmitRegistration();

  const formContext = useForm({
    resolver: yupResolver(registrationFormSchema()),
  });

  useEffect(() => {
    if (data) {
      formContext.reset({
        e03_id: data?.data?.row?.e03_id,
        e03_businessname: data?.data?.row?.e03_businessname,
        e03_afm: data?.data?.row?.e03_afm,
        d05_descr: data?.data?.row?.d08_descr,
      });
    }
  }, [data, error]);

  const fields = [
    {
      label: t("Αριθμός Γ.Ε.ΜΗ. Επιχείρησης"),
      name: "e03_id",
      required: true,
      disabled: true,
      minWidth: "17em",
      type: "text",
    },
    {
      label: t("ΑΦΜ Επιχείρησης"),
      name: "e03_afm",
      required: true,
      disabled: true,
      type: "text",
    },
    {
      label: t("Επωνυμία Επιχείρησης"),
      name: "e03_businessname",
      required: true,
      disabled: true,
      type: "text",
    },
    {
      label: t("Νομική μορφή"),
      name: "d05_descr",
      required: true,
      disabled: true,
      type: "text",
    },
    {
      label: t("Επιθυμητό Username"),
      name: "m01_username",
      required: true,
      type: "text",
    },
    {
      label: t("Νέο Password"),
      name: "m01_password1",
      required: true,
      type: "password",
    },
    {
      label: t("Νέο Password (επιβεβαίωση)"),
      name: "m01_password2",
      required: true,
      minWidth: "17em",
      type: "password",
    },
    {
      label: t("Email Επικοινωνίας"),
      name: "m01_email",
      required: true,
      type: "email",
    },
    {
      label: t("Επώνυμο υπεύθυνου για Επικοινωνία"),
      name: "m01_lastname",
      required: true,
      minWidth: "20em",
      type: "text",
    },
    {
      label: t("Όνομα υπεύθυνου για Επικοινωνία"),
      name: "m01_firstname",
      required: true,
      minWidth: "20em",
      type: "text",
    },
    {
      label: t("Τηλέφωνο Επικοινωνίας"),
      name: "m01_phone",
      required: true,
      type: "text",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "80vw",
        mx: "auto",
      }}
    >
      <Box>
        <Typography variant="h5">
          {t("Εγγραφή χρήστη στις υπηρεσίες εξωστρέφειας ΓΕΜΗ")}
        </Typography>
        <Typography variant="subtitle2">
          {t("Με (*) τα υποχρεωτικά πεδία")}
        </Typography>
      </Box>
      <Box>
        <FormContainer
          formContext={formContext}
          onSuccess={(data: FieldValues) => {
            mutate(data);
          }}
          onError={(formError) => {
            Object.entries(formError).forEach(([key, value]) => {
              value?.message
                ? enqueueSnackbar(value?.message, {
                    variant: "error",
                  })
                : null;
            });
          }}
        >
          <Box
            sx={{
              flexGrow: 3,
              width: "100%",
              mt: 10,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={3}
              rowSpacing={3}
              columns={4}
              sx={{
                justifyContent: {
                  xs: "center",
                  md: "flex-start",
                },
              }}
            >
              {fields.map((field, index) => (
                <Grid item>
                  <TextFieldElement
                    sx={{ minWidth: field.minWidth }}
                    name={field.name}
                    disabled={field.disabled}
                    label={field.label}
                    type={field.type}
                    required={field.required}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 5,
            }}
          >
            <LoadingButton
              variant="contained"
              type="submit"
              loading={isLoadingSubmit}
              sx={{ height: "60%" }}
            >
              {t("Εγγραφή")}
            </LoadingButton>
          </Box>
        </FormContainer>
      </Box>
    </Box>
  );
}

export default RegistrationForm;
